import { ADD_FILE, DOWNLOAD_FILE, REMOVE_FILE, UPDATE_FILE_UPLOAD_PROGRESS, UPLOAD_FILES } from './actionTypes';
/**
 * Upload files.
 *
 * @param {File[]} files - The files to upload.
 * @returns {Object}
 */
export function uploadFiles(files) {
    return {
        type: UPLOAD_FILES,
        files
    };
}
/**
 * Update a file's upload progress.
 *
 * @param {string} fileId - The ID of the file to update.
 * @param {number} progress - The new progress value.
 * @returns {Object}
 */
export function updateFileProgress(fileId, progress) {
    return {
        type: UPDATE_FILE_UPLOAD_PROGRESS,
        fileId,
        progress
    };
}
/**
 * Add a file.
 *
 * @param {IFileMetadata} file - The file to add to the state.
 * @param {boolean} shouldIncrementUnread - Whether to increment the unread count.
 * @returns {Object}
 */
export function addFile(file, shouldIncrementUnread = false) {
    return {
        type: ADD_FILE,
        file,
        shouldIncrementUnread
    };
}
/**
 * Remove a file from the backend.
 *
 * @param {string} fileId - The ID of the file to remove.
 * @returns {Object}
 */
export function removeFile(fileId) {
    return {
        type: REMOVE_FILE,
        fileId
    };
}
/**
 * Download a file.
 *
 * @param {string} fileId - The ID of the file to download.
 * @returns {Object}
 */
export function downloadFile(fileId) {
    return {
        type: DOWNLOAD_FILE,
        fileId
    };
}
